import Button from '@material-ui/core/Button'
import { withStyles } from '@material-ui/core/styles'
import { COLOR_SECUNDARIO_DARK } from 'cfgCommon/colors'

export const MainButton = withStyles(theme => {

    const primaryStyle = {
        border: '1px solid transparent',
        '&:disabled': {
            backgroundColor: `${theme.palette.grey[300]} !important`,
            color: `${theme.palette.grey[100]} !important`,
            '& .MuiButton-label': {
                pointerEvents: 'none',
            }
        },
        '&:hover': {
            backgroundColor: theme.palette.primary.light,
            boxShadow: 'none',
        },
        '&:active': {
            backgroundColor: theme.palette.primary.dark,
            boxShadow: 'none',
        },
        '&:focus': {
            boxShadow: `0px 0px 5px ${theme.palette.primary.light}a1`,
            borderColor: theme.palette.primary.light
        },
        '&.dark': {
            backgroundColor: theme.palette.grey[100],
            color: theme.palette.primary.main,
            border: '1px solid transparent',
            '&:hover': {
                backgroundColor: theme.palette.primary.dark,
                color: theme.palette.grey[100]
            },
            '&:active&:focus': {
                backgroundColor: theme.palette.primary.light,
                color: theme.palette.grey[100]
            },
            '&:focus': {
                boxShadow: `0px 0px 5px ${theme.palette.primary.light}a1, 0px 0px 0px 1px ${theme.palette.primary.light}`,
                backgroundColor: theme.palette.primary.dark,
                color: theme.palette.grey[100]
            },
            '&.Mui-disabled': {
                backgroundColor: 'rgba(255, 255, 255, 0.3)',
                color: 'rgba(255, 255, 255, 0.3)'
            }
        }
    }

    const secondaryStyle = {
        '&.btn-transparent': {
            backgroundColor: 'transparent',
        },
        '&:disabled': {
            color: theme.palette.grey[400],
            borderColor: theme.palette.grey[400],
        },
        '&:active&:focus': {
            backgroundColor: theme.palette.grey[300],
            boxShadow: 'none',
        },
        '&:focus': {
            borderColor: theme.palette.primary.light,
            boxShadow: `0px 0px 5px ${theme.palette.primary.light}a1`,
            backgroundColor: theme.palette.grey[200]
        },
        '&.dark': {
            boxShadow: `0px 0px 0px 1px ${theme.palette.grey[100]}`,
            color: theme.palette.grey[100],
            borderColor: 'transparent',
            backgroundColor: 'transparent',
            '&:hover': {
                backgroundColor: theme.palette.primary.dark
            },
            '&.Mui-disabled': {
                boxShadow: `0px 0px 0px 1px rgba(255, 255, 255, 0.3)`,
                color: 'rgba(255, 255, 255, 0.3)',
                backgroundColor: 'transparent'
            },
            '&:active': {
                backgroundColor: theme.palette.primary.light
            },
            '&:focus': {
                backgroundColor: theme.palette.grey[100],
                boxShadow: `0px 0px 0px 1px ${theme.palette.grey[100]}`,
                color: theme.palette.primary.main
            },
            '&:hover&:focus': {
                color: theme.palette.primary.main
            }
        }
    }

    // no existe estilo sizeMedium en Material, hace referencia al valor x defecto.
    const sizeMedium = {
        height: '40px',
        padding: '10px 16px',
        fontSize: '12px',
        lineHeight: '16px',
        '& .MuiButton-label': {
            minWidth: '51px',
            lineHeight: '16px',
            fontWeight: '700'
        },
        '& .MuiButton-startIcon': {
            display: 'inherit',
            marginLeft: '-4px',
            marginRight: '10px'
        },
        '& .MuiButton-endIcon': {
            display: 'inherit',
            marginLeft: '10px',
            marginRight: '-4px',
        }
    }

    const floatingDot = {
        position: 'absolute',
        top: '6px',
        right: '6px',
        width: '8px',
        height: '8px',
        backgroundColor: COLOR_SECUNDARIO_DARK,
        border: '1px solid white',
        borderRadius: '50%'
    }

    return {

        root: {
            width: 'max-content',
            maxHeight: '38px',
            borderRadius: '5px',
            '&:focus': {
                outline: 'none'
            },
            boxShadow: 'none',

            // Medium x defecto
            ...sizeMedium,

            '&.MuiButton-sizeSmall': {
                height: '31px',
                padding: '8px 10px',
                fontSize: '11px',

                '& .MuiButton-label': {
                    minWidth: '47px',
                    maxWidth: '47px',
                    width: '47px',
                    fontWeight: '700',
                    lineHeight: '15px',
                },
            },
            // aún no se usa desde UX, por ahora se setea como default (medium)
            '&.MuiButton-sizeLarge': {
                ...sizeMedium,

            },

            '&.onlyIcon': {
                minWidth: 0, // habilita que baje de 64px
                padding: '10px 12px',
                width: '44px',
                height: '40px',
                borderRadius: '5px',
                '& .MuiButton-label': {
                    // centrado del contenido del span con el icono dentro
                    display: 'flex',
                    justifyContent: 'center'
                },
                '& .MuiButton-startIcon, .MuiButton-endIcon': {
                    // quita bordes para centrar icono
                    margin: '0px !important',
                    padding: '0px !important'
                },
                '&.MuiSvgIcon-root': {
                    // tamaño del icono
                    width: '20px',
                    height: '20px'
                },

                '&.MuiButton-sizeSmall': {
                    height: '31px',
                    padding: '8px 10px',
                    width: '35px',
                },
            },

            //Primary
            '&.primary': {
                backgroundColor: theme.palette.primary.main,
                color: theme.palette.grey[50],
                ...primaryStyle
            },
            '&.MuiButton-containedPrimary': primaryStyle,

            // secondary
            '&.secondary': {
                backgroundColor: theme.palette.grey[100],
                border: `1px solid ${theme.palette.primary.main}`,
                color: theme.palette.primary.main,
                ...secondaryStyle
            },
            '&.MuiButton-outlinedPrimary': secondaryStyle,

            '&.tertiary': {
                color: theme.palette.primary.main,
                border: '1px solid transparent',

                '&:hover': {
                    color: theme.palette.primary.light,
                    backgroundColor: 'transparent'
                },
                '&:active': {
                    color: theme.palette.primary.main,
                    backgroundColor: theme.palette.grey[300],
                },
                '&:active&:focus': {
                    backgroundColor: theme.palette.grey[300],
                    borderColor: 'transparent',
                    boxShadow: 'none'
                },
                '&:focus': {
                    boxShadow: `0px 0px 5px ${theme.palette.primary.light}a1`,
                    borderColor: theme.palette.primary.light
                },
                '&.Mui-disabled': {
                    color: theme.palette.grey[400]
                },
                '&.dark': {
                    color: theme.palette.grey[100],
                    backgroundColor: 'transparent',
                    borderRadius: '5px',
                    borderColor: 'transparent',
                    '&:hover': {
                        color: theme.palette.grey[400]
                    },
                    '&.Mui-disabled': {
                        color: 'rgba(255, 255, 255, 0.3)'
                    },
                    '&:active&:focus': {
                        backgroundColor: theme.palette.grey[300],
                        color: theme.palette.primary.main,
                        borderColor: 'transparent'
                    },
                    '&:focus': {
                        backgroundColor: theme.palette.grey[100],
                        color: theme.palette.primary.main,
                        boxShadow: 'none',
                        borderColor: 'transparent'
                    }
                },
                '&.small': {
                    padding: '8px 10px',
                    fontSize: '11px'
                }
            },
            '&.link': {
                color: theme.palette.primary.main,
                border: '1px solid transparent',
                borderRadius: '4px',
                textTransform: 'none',
                minWidth: 'unset',
                maxHeight: '24px',
                minHeight: '24px',
                letterSpacing: '0.135px',

                '&:disabled': {
                    color: theme.palette.grey[400],
                },
                '&:hover': {
                    color: theme.palette.primary.main,
                    backgroundColor: 'transparent',
                    textDecoration: 'underline'
                },
                '&:focus': {
                    borderColor: theme.palette.primary.main
                },
                '&:hover &:focus': {
                    color: theme.palette.primary.main
                },
                '&.Mui-disabled': {
                    color: theme.palette.grey[400]
                },
                '&.dark': {
                    color: theme.palette.grey[100],
                    backgroundColor: 'transparent',
                    '&:hover': {
                        textDecoration: 'underline',
                        color: theme.palette.grey[100],
                    },
                    '&.Mui-disabled': {
                        color: 'rgba(255, 255, 255, 0.3)'
                    },
                    '&:focus': {
                        borderColor: theme.palette.grey[100]
                    },
                    '&:hover &:focus': {
                        color: theme.palette.grey[100]
                    }
                },
                '& .MuiButton-label': {
                    minWidth: '54px',
                    fontWeight: '400',
                    lineHeight: '24px',
                    letterSpacing: '0.135px',
                },
                '& .MuiButton-startIcon': {
                    display: 'inherit',
                    marginLeft: '0px',
                    marginRight: '6px'
                },
                '& .MuiButton-endIcon': {
                    display: 'inherit',
                    marginLeft: '6px',
                    marginRight: '0px',
                },
                '& .MuiTypography-body1': {
                    minWidth: '54px',
                    fontWeight: '400',
                    lineHeight: '24px',
                    letterSpacing: '0.135px'
                }

            },
            '& .MuiButton-iconSizeSmall > *:first-child': {
                fontSize: '15px'
            },

            '& .floating-dot': {...floatingDot}

        }
    }
})(Button)


